
export default {

    head() {
        return {
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.pageDescription
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.pageOGTitle
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.pageDescription
                },
                {
                    hid: 'twitter:image',
                    name: 'twitter:image',
                    content: this.coverURL
                },
                {
                    hid: 'twitter:image:alt',
                    name: 'twitter:image:alt',
                    content: this.coverTitle
                },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.pageOGTitle
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: this.pageDescription
                },
                {
                    hid: 'og:image',
                    property: 'og:image',
                    content: this.coverURL
                },
                {
                    hid: 'og:image:secure_url',
                    property: 'og:image:secure_url',
                    content: this.coverURL
                },
                {
                    hid: 'og:image:alt',
                    property: 'og:image:alt',
                    content: this.coverTitle
                }
            ]
        }
    },

    props: {
        region: Object
    },

    data() {
        return {
            creditVisible: false,

            // Titre open graph et twitter de la page
            pageOGTitle:
                (this.region.parent)
                    ? `Les communes du département ${this.region.name}.`
                    : `La région ${this.region.name}.`,

            // URL top background (utilisé également pour open graph et twitter)
            coverURL: (this.region.cover_url == "" && this.region.parent != null) ? this.region.parent.cover_url : this.region.cover_url,

            // SrcSet
            coverSrcSet: (this.region.cover_srcset.length)
                ? this.region.cover_srcset[0]
                : ((this.region.parent && this.region.parent.cover_srcset.length) ? this.region.parent.cover_srcset[0] : ''),

            // infos crédits auteur image
            coverAuthor: (this.region.cover_infos)
                ? this.region.cover_infos.properties.credit_author
                : ((this.region.parent && this.region.parent.cover_infos) ? this.region.parent.cover_infos.properties.credit_author : ''),

            // description de l'image
            coverTitle: (this.region.parent)
                ? `Département : ${this.region.name}`
                : `Région : ${this.region.name}`
        }
    },

    methods: {
        set: function (creditVisible) {
            var self = this;
            this.creditVisible = !creditVisible;
            return this.$emit('update:credit-button', this.creditVisible);
        }
    },
}
